import React from "react";
//#region redux
import { ThunkDispatch } from "redux-thunk";
import { useDispatch } from "react-redux";
import { displayDialog } from "store/actions/utilActions";
import { salaryDraftAccepted, salaryDraftRejected } from "store/actions/salaryDraftActions";
//#endregion
//#region types
import { AuthEnums, StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { SalaryDraftFooterProps } from "models/propTypes/salaryPropTypes";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion
//#region components
import { PageFooter } from "components/common";
import useSalaryDraftRejectDialog from "./forms/useSalaryDraftRejectDialog";
import SalaryDraftMoreActions from "./moreActions";
import { useSalaryService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import { CompanyService } from "services";

const SalaryDraftFooter: React.FC<SalaryDraftFooterProps> = (props) => {
  const salaryService = useSalaryService();
  const { salaryDraft, markAsDoneHandler, disableSuccessMessages } = props;

  const dispatch: ThunkDispatch<any, any, any> = useDispatch();

  const onAcceptSuccess = () => {
    markAsDoneHandler && markAsDoneHandler();
    dispatch(salaryDraftAccepted(salaryDraft.id));
  };

  const onSalaryDraftAccept = () => {
    return salaryService.acceptSalaryDraft(salaryDraft.id);
  };

  const actionPermission = () => {
    const isAuditor = CompanyService.hasRelation(AuthEnums.PersonCompanyRelationType.Auditor);
    return salaryDraft.state === WintSuperkollAPIModel.SalaryDraftState.AtCustomer && !isAuditor;
  };

  const onSalaryDraftRejected = async () => {
    dispatch(displayDialog(getRejectDialog(props.salaryDraft.id)));
  };

  const isInValidState = (error?: { status: number; codes: string[] }) => {
    return (
      error?.codes.some(
        (error) =>
          error === TranslationKeys.Errors.InvalidStateForUpdate ||
          error === TranslationKeys.Errors.AlreadyHasSameAssigneeAndState ||
          error === TranslationKeys.Errors.InvalidStateForReassignment
        // eslint-disable-next-line eqeqeq --- since checked against different types
      ) || error?.status == 403
    );
  };

  const onActionError = (error?: any, closeDialog?: () => void) => {
    if (isInValidState(error)) {
      setTimeout(() => {
        closeDialog && closeDialog();
        markAsDoneHandler && markAsDoneHandler();
        dispatch(salaryDraftAccepted(salaryDraft.id));
      }, 3000);
    }
  };

  const onRejectSuccess = () => {
    markAsDoneHandler && markAsDoneHandler();
    dispatch(salaryDraftRejected(salaryDraft.id));
  };

  const getRejectDialog = useSalaryDraftRejectDialog(onRejectSuccess, onActionError, disableSuccessMessages);

  return (
    <PageFooter
      actions={
        actionPermission()
          ? [
              {
                text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Reject),
                onClick: onSalaryDraftRejected,
                type: StyleEnums.DisplayType.Danger,
              },
              {
                text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Approve),
                onClick: onSalaryDraftAccept,
                type: StyleEnums.DisplayType.Success,
                successMessage: LocalizationHelperInstance.getFormattedMessage(
                  TranslationKeys.Salary.SalaryDraftAcceptSuccessMessage
                ),
                onActionSuccess: onAcceptSuccess,
                onActionError: onActionError,
              },
            ]
          : []
      }
      moreActions={
        <SalaryDraftMoreActions onError={onActionError} salaryDraft={salaryDraft} markAsDone={markAsDoneHandler} />
      }
      disableSuccessMessages={disableSuccessMessages}
    />
  );
};

export default SalaryDraftFooter;
